import { render, staticRenderFns } from "./ChatTriggers.vue?vue&type=template&id=0e22b798&scoped=true&"
import script from "./ChatTriggers.vue?vue&type=script&lang=js&"
export * from "./ChatTriggers.vue?vue&type=script&lang=js&"
import style0 from "./ChatTriggers.vue?vue&type=style&index=0&id=0e22b798&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e22b798",
  null
  
)

export default component.exports